// ----------------------------------------------------------------------

const STORAGE_PREFIX = 'jt_session_';

export function sessionStorageAvailable() {
  try {
    const key = '__some_random_key_you_are_not_going_to_use__';
    sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, key);
    sessionStorage.removeItem(`${STORAGE_PREFIX}${key}`);
    return true;
  } catch (error) {
    return false;
  }
}

export function sessionStorageSetItem(key: string, value: any) {
  const storageAvailable = sessionStorageAvailable();

  if (storageAvailable) {
    sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, value);
  }
}

export function sessionStorageRemoveItem(key: string) {
  sessionStorage.removeItem(`${STORAGE_PREFIX}${key}`);
}

export function sessionStorageGetItem(key: string, defaultValue = '') {
  const storageAvailable = sessionStorageAvailable();

  let value;

  if (storageAvailable) {
    value = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`) || defaultValue;
  }

  return value;
}